'use strict';

angular.module('betosyswebapp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('home', {
        parent: 'app',
        url: '/',
        views: {
          'content@app': {
            templateUrl: 'components/home/home.tpl.html',
            controller: 'MainController',
            controllerAs: 'framework'
          }
        },
        resolve: {
          $title: function () {
            return 'DSA';
          },
          $sibebar: ['AdmStatusService', function (AdmStatusService) {
            AdmStatusService.setSidebarVisible(false);
            return false;
          }]
        }
      });
  });



// WEBPACK FOOTER //
// ./.tmp/components/home/home.route.js